export const textSwe=[
    "RIKSDAGEN FÖR FRAMTIDEN",
    "- KLIMATBESLUT NU!",
    "Mejla en riksdagsledamot för en framtid inom planetens gränser.",
    "Läs mer",
    "Hur gör jag?",
]